import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MunicipalityManagementComponent } from '@app/municipality-management/municipality-management.component';
import { MunicipalityOnboardingComponent } from '@app/municipality-onboarding/municipality-onboarding.component';
import { RegionManagementDeactivateGuard } from '@app/region-management/guards/region-management.guard';
import { MyPersonalDataComponent } from '../my-personal-data/my-personal-data.component';
import { RegionManagementComponent } from '../region-management/region-management.component';
import { ReleaseNoteAdminComponent } from '../release-note-admin/release-note-admin.component';
import { UserListComponent } from '../user-list/user-list.component';
import { ManagementTabsComponent } from './management-tabs.component';
import { MunicipalityManagementNavigationGuard } from '@app/municipality-management/guards/municipality-management-navigation.guard';

const userProfileRoutes: Routes = [
  {
    path: '',
    component: ManagementTabsComponent,
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'meine-persönlichen-daten',
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'meine-persönlichen-daten',
        component: MyPersonalDataComponent,
        data: { permissionCodes: ['PERSONAL_DATA'] },
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'benutzerverwaltung',
        component: UserListComponent,
        data: { permissionCodes: ['USER_MANAGEMENT'] },
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'kommunenverwaltung',
        component: MunicipalityManagementComponent,
        data: { permissionCodes: ['GENERAL_CONFIGURATION'] },
        canDeactivate: [MunicipalityManagementNavigationGuard],
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'neuerungen-verwalten',
        component: ReleaseNoteAdminComponent,
        data: { permissionCodes: ['RELEASE_NOTE_ADMIN'] },
        runGuardsAndResolvers: 'always',
      },
      {
        path: 'regionenverwaltung',
        component: RegionManagementComponent,
        data: { permissionCodes: ['REGION_MANAGEMENT'] },
        runGuardsAndResolvers: 'always',
        canDeactivate: [RegionManagementDeactivateGuard],
      },
      {
        path: 'kommunen-onboarding',
        component: MunicipalityOnboardingComponent,
        data: { permissionCodes: ['KOMMUNEN_ONBOARDING'] },
        runGuardsAndResolvers: 'always',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(userProfileRoutes)],
  exports: [RouterModule],
})
export class ManagementTabsRoutingModule {}
